import { ConfigAuditPage } from "@/features/admin/ConfigAuditPage";
import { useAppShell } from "@/shell/app-shell-context";

export function ConfigAuditRoute() {
  const { token } = useAppShell();
  return <ConfigAuditPage token={token} />;
}
